/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guidevideo_Load_Failed1Inputs */

const vi_guidevideo_load_failed1 = /** @type {(inputs: Guidevideo_Load_Failed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được danh sách video. Kiểm tra mạng rồi tải lại trang.`)
};

/**

* @param {Guidevideo_Load_Failed1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const guidevideo_load_failed1 = /** @type {((inputs?: Guidevideo_Load_Failed1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guidevideo_Load_Failed1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_guidevideo_load_failed1(inputs)
});
export { guidevideo_load_failed1 as "guideVideo_load_failed" }